import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { LoginCredentials, LoginResponse, RefreshResponse, ValidateResponse } from '@/types';
import { getAccessToken } from '@/utils/jwt';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL ?? '/api',
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials,
      }),
    }),

    logout: builder.mutation<{ success: boolean }, undefined>({
      query: () => ({
        url: '/logout',
        method: 'POST',
      }),
    }),

    refreshToken: builder.mutation<RefreshResponse, { refresh_token: string }>({
      query: (body) => ({
        url: '/jwt/refresh',
        method: 'POST',
        body,
      }),
    }),

    validateToken: builder.mutation<ValidateResponse, undefined>({
      query: () => ({
        url: '/jwt/validate',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useValidateTokenMutation,
} = authApi;
